import React, { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import {
	SubscriptionApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorContentApi, PriceConfiguratorPlanApi } from "../../../../../../../../services/Api/types";
import { splitDateWithComma } from "../Preview/SingleSubscriptionPreview";
import UninstalledSubscription from "./components/UninstalledSubscription";

interface Props {
	estimate?: SubscriptionApi;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	index: number;
	onResume: () => void;
	editable: boolean;
	config: PriceConfiguratorContentApi;
	plan?: PriceConfiguratorPlanApi;
}

const PausedSubscription: FC<Props> = (props: Props) => {
	const { watch } = props.form;
	const { t } = useTranslation();
	const watchedStatus = watch(`subscriptions.${props.index}.status`);

	if (!props.plan) {
		return <>READONLY</>;
	}
	const isEditable = props.plan.edit_mode === "EDITABLE";

	const getDate = () => {
		const pauseDate = props.estimate?.pause_date;
		const resumeDate = props.estimate?.resume_date;
		if (!pauseDate || !resumeDate) return undefined;
		return `${t("lib:common.word.from")} ${splitDateWithComma(FormatDate(pauseDate))} ${t(
			"lib:common.word.to"
		)} ${splitDateWithComma(FormatDate(resumeDate))}`;
	};

	return (
		<UninstalledSubscription
			familyId={props.config.family_id}
			planName={props.plan.name}
			planDescription={props.plan.description}
			editable={isEditable}
			status={watchedStatus}
			date={getDate()}
			handleResume={props.onResume}
		/>
	);
};

export default PausedSubscription;
